import { z } from 'zod';

import { toSessionDTO, type SessionDTO } from './get-sessions.schema';

// ── Response ───────────────────────────────────────────
export type GetSessionDTO = SessionDTO;

const GetSessionApiSchema = z
  .object({
    result: z.unknown(),
  })
  .transform(raw => toSessionDTO(raw.result));

export function toGetSessionDTO(raw: unknown): GetSessionDTO {
  return GetSessionApiSchema.parse(raw);
}
